export const languagesData = [
    { value: 'afrikaans', label: 'Afrikaans', color: '#3454d1' },
    { value: 'albanian', label: 'Albanian - shqip', color: '#ffa21d' },
    { value: 'amharic', label: 'Amharic - አማርኛ', color: '#00b9ff' },
    { value: 'arabic', label: 'Arabic - العربية', color: '#00ad84' },
    { value: 'aragonese', label: 'Aragonese - aragonés', color: '#000000' },
    { value: 'armenian', label: 'Armenian - հայերեն', color: '#009688' },
    { value: 'asturian', label: 'Asturian - asturianu', color: '#00c853' },
    { value: 'azerbaijani', label: 'Azerbaijani - azərbaycan dili', color: '#00b9ff' },
    { value: 'basque', label: 'Basque - euskara', color: '#3f51b5' },
    { value: 'belarusian', label: 'Belarusian - беларуская', color: '#009688' },
    { value: 'bengali', label: 'Bengali - বাংলা', color: '#000000' },
    { value: 'bosnian', label: 'Bosnian - bosanski', color: '#00ad84' },
    { value: 'breton', label: 'Breton - brezhoneg', color: '#3454d1' },
    { value: 'bulgarian', label: 'Bulgarian - български', color: '#ffa21d' },
    { value: 'catalan', label: 'Catalan - català', color: '#009688' },
    { value: 'central-kurdish', label: 'Central Kurdish - کوردی (دەستنوسی عەرەبی)', color: '#000000' },
    { value: 'chinese', label: 'Chinese - 中文', color: '#00ad84' },
    { value: 'chinese-hong-kong', label: 'Chinese (Hong Kong) - 中文（香港）', color: '#00b9ff' },
    { value: 'chinese-simplified', label: 'Chinese (Simplified) - 中文（简体）', color: '#3454d1' },
    { value: 'chinese-traditional', label: 'Chinese (Traditional) - 中文（繁體）', color: '#d50000' },
    { value: 'corsican', label: 'Corsican', color: '#00b9ff' },
    { value: 'croatian', label: 'Croatian - hrvatski', color: '#000000' },
    { value: 'czech', label: 'Czech - čeština', color: '#ffa21d' },
    { value: 'danish', label: 'Danish - dansk', color: '#3454d1' },
    { value: 'dutch', label: 'Dutch - Nederlands', color: '#009688' },
    { value: 'english', label: 'English', color: '#d50000' },
    { value: 'english-australia', label: 'English (Australia)', color: '#00ad84' },
    { value: 'english-canada', label: 'English (Canada)', color: '#000000' },
    { value: 'english-india', label: 'English (India)', color: '#00b9ff' },
    { value: 'english-new-zealand', label: 'English (New Zealand)', color: '#3454d1' },
    { value: 'english-south-africa', label: 'English (South Africa)', color: '#3f51b5' },
    { value: 'english-united-kingdom', label: 'English (United Kingdom)', color: '#000000' },
    { value: 'english-united-states', label: 'English (United States)', color: '#009688' },
    { value: 'esperanto', label: 'Esperanto - esperanto', color: '#00ad84' },
    { value: 'estonian', label: 'Estonian - eesti', color: '#00b9ff' },
    { value: 'faroese', label: 'Faroese - føroyskt', color: '#3454d1' },
    { value: 'filipino', label: 'Filipino', color: '#000000' },
    { value: 'finnish', label: 'Finnish - suomi', color: '#00b9ff' },
    { value: 'french', label: 'French - français', color: '#3454d1' },
    { value: 'french-canada', label: 'French (Canada) - français (Canada)', color: '#00c853' },
    { value: 'french-france', label: 'French (France) - français (France)', color: '#ffa21d' },
    { value: 'french-switzerland', label: 'French (Switzerland) - français (Suisse)', color: '#000000' },
    { value: 'galician', label: 'Galician - galego', color: '#3454d1' },
    { value: 'georgian', label: 'Georgian - ქართული', color: '#009688' },
    { value: 'german', label: 'German - Deutsch', color: '#000000' },
    { value: 'german-austria', label: 'German (Austria) - Deutsch (Österreich)', color: '#00ad84' },
    { value: 'german-germany', label: 'German (Germany) - Deutsch (Deutschland)', color: '#d50000' },
    { value: 'german-liechtenstein', label: 'German (Liechtenstein) - Deutsch (Liechtenstein)', color: '#3f51b5' },
    { value: 'german-switzerland', label: 'German (Switzerland) - Deutsch (Schweiz)', color: '#00b9ff' },
    { value: 'greek', label: 'Greek - Ελληνικά', color: '#3454d1' },
    { value: 'guarani', label: 'Guarani', color: '#00ad84' },
    { value: 'gujarati', label: 'Gujarati - ગુજરાતી', color: '#009688' },
    { value: 'hausa', label: 'Hausa', color: '#00c853' },
    { value: 'hawaiian', label: 'Hawaiian - ʻŌlelo Hawaiʻi', color: '#3454d1' },
    { value: 'hebrew', label: 'Hebrew - עברית', color: '#00b9ff' },
    { value: 'hindi', label: 'Hindi - हिन्दी', color: '#ffa21d' },
    { value: 'hungarian', label: 'Hungarian - magyar', color: '#00ad84' },
    { value: 'icelandic', label: 'Icelandic - íslenska', color: '#000000' },
    { value: 'indonesian', label: 'Indonesian - Indonesia', color: '#d50000' },
    { value: 'interlingua', label: 'Interlingua', color: '#3454d1' },
    { value: 'irish', label: 'Irish - Gaeilge', color: '#00ad84' },
    { value: 'italian', label: 'Italian - italiano', color: '#00c853' },
    { value: 'italian-italy', label: 'Italian (Italy) - italiano (Italia)', color: '#00b9ff' },
    { value: 'italian-switzerland', label: 'Italian (Switzerland) - italiano (Svizzera)', color: '#009688' },
    { value: 'japanese', label: 'Japanese - 日本語', color: '#3f51b5' },
    { value: 'kannada', label: 'Kannada - ಕನ್ನಡ', color: '#3454d1' },
    { value: 'kazakh', label: 'Kazakh - қазақ тілі', color: '#00b9ff' },
    { value: 'khmer', label: 'Khmer - ខ្មែរ', color: '#000000' },
    { value: 'korean', label: 'Korean - 한국어', color: '#3454d1' },
    { value: 'Kurdish', label: 'Kurdish - Kurdî', color: '#f58025' },
    { value: 'Kyrgyz', label: 'Kyrgyz - кыргызча', color: 'lightblue' },
    { value: 'Lao', label: 'Lao - ລາວ', color: 'red' },
    { value: 'Latin', label: 'Latin', color: '#3454d1' },
    { value: 'Latvian', label: 'Latvian - latviešu', color: 'orange' },
    { value: 'Lingala', label: 'Lingala - lingála', color: 'green' },
    { value: 'Lithuanian', label: 'Lithuanian - lietuvių', color: 'black' },
    { value: 'Macedonian', label: 'Macedonian - македонски', color: '#3454d1' },
    { value: 'Malay', label: 'Malay - Bahasa Melayu', color: 'indigo' },
    { value: 'Malayalam', label: 'Malayalam - മലയാളം', color: 'green' },
    { value: 'Maltese', label: 'Maltese - Malti', color: 'lightblue' },
    { value: 'Marathi', label: 'Marathi - मराठी', color: 'teal' },
    { value: 'Mongolian', label: 'Mongolian - монгол', color: '#3454d1' },
    { value: 'Nepali', label: 'Nepali - नेपाली', color: 'red' },
    { value: 'Norwegian', label: 'Norwegian - norsk', color: 'green' },
    { value: 'Norwegian Bokmål', label: 'Norwegian Bokmål - norsk bokmål', color: '#f58025' },
    { value: 'Norwegian Nynorsk', label: 'Norwegian Nynorsk - nynorsk', color: '#3454d1' },
    { value: 'Occitan', label: 'Occitan', color: 'success' },
    { value: 'Oriya', label: 'Oriya - ଓଡ଼ିଆ', color: 'lightblue' },
    { value: 'Oromo', label: 'Oromo - Oromoo', color: 'black' },
    { value: 'Pashto', label: 'Pashto - پښتو', color: 'red' },
    { value: 'Persian', label: 'Persian - فارسی', color: 'green' },
    { value: 'Polish', label: 'Polish - polski', color: '#3454d1' },
    { value: 'Portuguese', label: 'Portuguese - português', color: 'teal' },
    { value: 'Portuguese (Brazil)', label: 'Portuguese (Brazil) - português (Brasil)', color: 'red' },
    { value: 'Portuguese (Portugal)', label: 'Portuguese (Portugal) - português (Portugal)', color: 'black' },
    { value: 'Punjabi', label: 'Punjabi - ਪੰਜਾਬੀ', color: 'green' },
    { value: 'Quechua', label: 'Quechua', color: 'indigo' },
    { value: 'Romanian', label: 'Romanian - română', color: 'success' },
    { value: 'Romanian (Moldova)', label: 'Romanian (Moldova) - română (Moldova)', color: '#f58025' },
    { value: 'Romansh', label: 'Romansh - rumantsch', color: '#3454d1' },
    { value: 'Russian', label: 'Russian - русский', color: 'red' },
    { value: 'Scottish Gaelic', label: 'Scottish Gaelic', color: 'green' },
    { value: 'Serbian', label: 'Serbian - српски', color: 'orange' },
    { value: 'Serbo-Croatian', label: 'Serbo-Croatian', color: 'teal' },
    { value: 'Shona', label: 'Shona - chiShona', color: '#3454d1' },
    { value: 'Sindhi', label: 'Sindhi', color: 'lightblue' },
    { value: 'Sinhala', label: 'Sinhala - සිංහල', color: 'black' },
    { value: 'Slovak', label: 'Slovak - slovenčina', color: '#f58025' },
    { value: 'Slovenian', label: 'Slovenian - slovenščina', color: 'red' },
    { value: 'Somali', label: 'Somali - Soomaali', color: 'green' },
    { value: 'Southern Sotho', label: 'Southern Sotho', color: '#3454d1' },
    { value: 'Spanish', label: 'Spanish - español', color: 'orange' },
    { value: 'Spanish (Argentina)', label: 'Spanish (Argentina) - español (Argentina)', color: 'indigo' },
    { value: 'Spanish (Latin America)', label: 'Spanish (Latin America) - español (Latinoamérica)', color: 'green' },
    { value: 'Spanish (Mexico)', label: 'Spanish (Mexico) - español (México)', color: 'lightblue' },
    { value: 'Spanish (Spain)', label: 'Spanish (Spain) - español (España)', color: 'black' },
    { value: 'Spanish (United States)', label: 'Spanish (United States) - español (Estados Unidos)', color: 'success' },
    { value: 'Sundanese', label: 'Sundanese', color: '#3454d1' },
    { value: 'Swahili', label: 'Swahili - Kiswahili', color: 'teal' },
    { value: 'Swedish', label: 'Swedish - svenska', color: 'green' },
    { value: 'Tajik', label: 'Tajik - тоҷикӣ', color: 'lightblue' },
    { value: 'Tamil', label: 'Tamil - தமிழ்', color: '#f58025' },
    { value: 'Tatar', label: 'Tatar', color: '#3454d1' },
    { value: 'Telugu', label: 'Telugu - తెలుగు', color: 'success' },
    { value: 'Thai', label: 'Thai - ไทย', color: 'black' },
    { value: 'Tigrinya', label: 'Tigrinya - ትግርኛ', color: 'green' },
    { value: 'Tongan', label: 'Tongan - lea fakatonga', color: 'teal' },
    { value: 'Turkish', label: 'Turkish - Türkçe', color: '#3454d1' },
    { value: 'Turkmen', label: 'Turkmen', color: 'red' },
    { value: 'Twi', label: 'Twi', color: 'indigo' },
    { value: 'Ukrainian', label: 'Ukrainian - українська', color: 'black' },
    { value: 'Urdu', label: 'Urdu - اردو', color: 'green' },
    { value: 'Uyghur', label: 'Uyghur', color: 'lightblue' },
    { value: 'Uzbek', label: 'Uzbek - o‘zbek', color: '#3454d1' },
    { value: 'Vietnamese', label: 'Vietnamese - Tiếng Việt', color: 'success' },
    { value: 'Walloon', label: 'Walloon - wa', color: 'lightblue' },
    { value: 'Welsh', label: 'Welsh - Cymraeg', color: '#3454d1' },
    { value: 'Western Frisian', label: 'Western Frisian', color: 'teal' },
    { value: 'Xhosa', label: 'Xhosa', color: '#f58025' },
    { value: 'Yiddish', label: 'Yiddish', color: 'indigo' },
    { value: 'Yoruba', label: 'Yoruba - Èdè Yorùbá', color: 'green' },
    { value: 'Zulu', label: 'Zulu - isiZulu', color: 'black' }
]